import { mergeAttributes, Node } from '@tiptap/core';
import { BoardLayout } from '@superthread-com/api';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    embedBoard: {
      /**
       * Embed a board
       */
      embedBoard: (options: { boardId: string }) => ReturnType;
    };
  }
}

export interface EmbedBoardOptions {
  plugins?: any[];
  HTMLAttributes?: Record<string, any>;
  tagName: string;
}

export default Node.create<EmbedBoardOptions>({
  name: 'embedBoard',

  addOptions() {
    return {
      HTMLAttributes: {},
      tagName: 'board-embed',
    };
  },

  group() {
    return 'block';
  },

  draggable: true,

  addStorage() {
    return {};
  },

  addAttributes() {
    return {
      'board-id': {
        isRequired: true,
        // make sure that the board id is always a string
        parseHTML: (element) => element.getAttribute('board-id'),
      },
      layout: {
        default: BoardLayout.Board,
      },
      'full-width': {
        default: true,
      },
      'read-only': {
        default: false,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'board-embed[board-id]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      this.options.tagName,
      mergeAttributes(this.options.HTMLAttributes || {}, HTMLAttributes),
    ];
  },

  addCommands() {
    return {
      embedBoard:
        (options) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: {
              ...options,
            },
          });
        },
    };
  },
});
